/* eslint-disable react/prop-types */
import React, { LegacyRef, forwardRef, useEffect, useState } from "react";
import { HiBadgeCheck, HiDocumentReport } from "react-icons/hi";
import PropTypes from "prop-types";

import { FaClipboardList, FaExclamationCircle, FaUserCheck, FaUserEdit } from "react-icons/fa";
import { TbFileReport } from "react-icons/tb";
import "./explanationOfBenefitFormPrint.css";
import ExplanationOfBenefitsGridPrint from "./ExplanationOfBenefitsGridPrint/ExplanationOfBenefitsGridPrint";
import Remarks from "../remarks/Remarks";
import {
	BOP_PandleFirstBank_logo,
	BrookshireBrothersCircleLogo,
	IntercityLogoDarkv2,
	nexcaliberLogo,
	PanhandleFirstBankLogo,
	ProgressiveLabsLogo
} from "../../../../../../../../../assets";
import { NEXCALIBER_DETAILS } from "../../../../../../../../../constants/nexcaliberDetails";
import { mongoDBDateParserToUSAFormat } from "../../../../../../../../../utils/commonFunctions/date";
import { GROUP_NUMBER } from "../../../../../../../../../constants/groups";
import { useQuery } from "../../../../../../../../../hooks";

const ExplanationOfBenefitFormPrint: React.ForwardRefExoticComponent<any> = forwardRef(
	// eslint-disable-next-line react/prop-types

	({ eobDetails }, ref): JSX.Element => {
		const query = useQuery();
		const [groupNumber, setGroupNumber] = useState<number | null>(null);
		useEffect(() => {
			if (query && query.get("number") && query.get("pre") && query.get("suffix")) {
				// const claim_no = query.get("number");
				// const claim_prefix = query.get("pre");
				// const claim_suffix = query.get("suffix");
				const groupNumber = query.get("gn");
				setGroupNumber(Number(groupNumber));
				// setClaimNo(Number(claim_no));
				// setClaimPrefix(Number(claim_prefix));
				// setClaimSuffix(Number(claim_suffix));
			}
		}, [query]);
		return (
			<div className="printable-EOB" ref={ref as unknown as LegacyRef<HTMLDivElement> | undefined}>
				<div className="EOB-paper-container">
					{/* ============================= HEADER CONTAINER ================================= */}
					<div className="header-container">
						{/* <div className="group-logo-container">
							<img src={BrookshireBrothersCircleLogo} className="group-logo" alt="" />
						</div> */}
						<div
							className={`group-logo-container ${
								groupNumber === GROUP_NUMBER.BBI_BROOKSHIRE_BROTHERS
									? "group-220"
									: groupNumber === GROUP_NUMBER.ICI_INTERCITY_INVESTMENTS
									? "group-188"
									: groupNumber === GROUP_NUMBER.PANHANDLE_FIRST_BANK
									? "group-PFB"
									: groupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES
									? "group-PL"
									: "group-default"
							}`}
						>
							<img
								src={
									groupNumber === GROUP_NUMBER.BBI_BROOKSHIRE_BROTHERS
										? BrookshireBrothersCircleLogo
										: groupNumber === GROUP_NUMBER.ICI_INTERCITY_INVESTMENTS
										? IntercityLogoDarkv2
										: groupNumber === GROUP_NUMBER.PANHANDLE_FIRST_BANK
										? BOP_PandleFirstBank_logo
										: groupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES
										? ProgressiveLabsLogo
										: BrookshireBrothersCircleLogo
								}
								className="group-logo"
								alt=""
							/>
						</div>
						<div className="nexcaliber-logo-container">
							<img src={nexcaliberLogo} className="nexcaliber-logo" alt="" />
							<div className="nexcaliber-location-details">
								<span>Nexcaliber</span>
								<span>PO BOX 802422, Dalas Texas 75380</span>
								<span>{NEXCALIBER_DETAILS.NEXCALIBER_CONTACT}</span>
							</div>
						</div>
					</div>
					<div className="subheading-main">
						<HiBadgeCheck />
						Explanation of Benefits
					</div>
					{/* ============================= BODY CONTAINER ====================================*/}
					<div className="eob-grid-container">
						<div className="eob-grid-item">
							<div className="category-heading">
								<FaUserCheck />
								<span>Subscriber</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">First Name</span>
								<span className="field-value">
									{eobDetails?.claimantSubscriberDetailsInstance[0].INSURED_FIRSTNAME}
								</span>
							</div>
							<span className="grid-item-fields">
								<div className="grid-item-fields">
									<span className="field-title">Last Name</span>
									<span className="field-value">
										{eobDetails?.claimantSubscriberDetailsInstance[0].INSURED_LASTNAME}
									</span>
								</div>
							</span>
							<span className="grid-item-fields">
								<div className="grid-item-fields">
									<span className="field-title">Address</span>
									<span className="field-value">
										{eobDetails?.claimantSubscriberDetailsInstance[0].ADDR1} (
										{eobDetails?.claimantSubscriberDetailsInstance[0].STATE}){" "}
										{eobDetails?.claimantSubscriberDetailsInstance[0].ZIPCODE}
									</span>
								</div>
							</span>
						</div>
						<div className="eob-grid-item">
							<div className="category-heading">
								<FaUserEdit />
								<span>Claimant</span>
							</div>
							<div className="claimant-container">
								<div className="left-section">
									<div className="grid-item-fields">
										<span className="field-title">Claim For</span>
										<span className="field-value">
											{eobDetails?.claimantSubscriberDetailsInstance[0].PATIENT_FIRSTNAME}{" "}
											{eobDetails?.claimantSubscriberDetailsInstance[0].PATIENT_LASTNAME}
										</span>
									</div>

									<div className="grid-item-fields">
										<span className="field-title">SSN</span>
										<span className="field-value">
											{eobDetails?.claimantSubscriberDetailsInstance[0].SSN}
										</span>
									</div>

									<div className="grid-item-fields">
										<span className="field-title">PPO No :</span>
										<span className="field-value">
											{" "}
											{eobDetails?.claimantSubscriberDetailsInstance[0]?.PPONO || "N/A"}
										</span>
									</div>

									<div className="grid-item-fields">
										<span className="field-title">Claim Number :</span>
										<span className="field-value">
											{eobDetails?.claimantSubscriberDetailsInstance[0].CLMNO}
										</span>
									</div>
								</div>
								<div className="right-section">
									<div className="grid-item-fields">
										<span className="field-title">Provider Check :</span>
										<span className="field-value">
											{eobDetails?.claimantSubscriberDetailsInstance[0].PRVCKNO}
										</span>
									</div>

									<div className="grid-item-fields">
										<span className="field-title">Paid Date :</span>
										{eobDetails?.claimantSubscriberDetailsInstance[0].PDDT ? (
											<span className="field-value">
												{mongoDBDateParserToUSAFormat(
													eobDetails?.claimantSubscriberDetailsInstance[0].PDDT
												)}
											</span>
										) : null}
									</div>
									<div className="grid-item-fields">
										<span className="field-title">PPO Name :</span>
										<span className="field-value">
											{eobDetails?.claimantSubscriberDetailsInstance[0]?.PPO_NAME || "N/A"}
										</span>
									</div>
								</div>
							</div>
						</div>
						<div className="eob-grid-item">
							<div className="category-heading">
								<FaClipboardList />
								<span>Provider Details</span>
							</div>
							<span>
								{eobDetails?.claimantSubscriberDetailsInstance[0].PRVNO} -{" "}
								{eobDetails?.claimantSubscriberDetailsInstance[0].IDSUFFIX}
							</span>
							<span>{eobDetails?.claimantSubscriberDetailsInstance[0].NAME}</span>
							<span>
								{eobDetails?.claimantSubscriberDetailsInstance[0].ADDR1_1} (
								{eobDetails?.claimantSubscriberDetailsInstance[0].STATE_1}){" "}
								{eobDetails?.claimantSubscriberDetailsInstance[0].ZIPCODE_1}
							</span>
							{/* <span>98 Nexcaliber Network</span> */}
						</div>
						<div className="eob-grid-item">
							<div className="category-heading">
								<FaExclamationCircle />
								<span>Claim Summary</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">Total Amount Covered:</span>
								<span className="field-value">
									{eobDetails?.claimSummaryDetailsInstance[0]["SUM(D.ADJCVRD)"]}
								</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">Paid by Insurrance company:</span>
								<span className="field-value">
									${eobDetails?.claimSummaryDetailsInstance[0]["SUM(D.COBAMT)"]}
								</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">Total Paid By plans:</span>
								<span className="field-value">
									{" "}
									${eobDetails?.claimSummaryDetailsInstance[0]["SUM(D.PLNRESP)"]}
								</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">Employee Responsibility:</span>
								<span className="field-value">
									{" "}
									${eobDetails?.claimSummaryDetailsInstance[0]["SUM(D.EERESP)"]}
								</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">In Network:</span>
								<span className="field-value">
									{" "}
									${eobDetails?.claimSummaryDetailsInstance[0]["SUM(D.DEDREMPPO)"]}
								</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">Out Of Pocket Remaining Plan:</span>
								<span className="field-value">
									{" "}
									${eobDetails?.claimSummaryDetailsInstance[0]["SUM(D.OOPREMPLN)"]}
								</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">Annual Accumulation:</span>
								<span className="field-value">
									{" "}
									${eobDetails?.claimSummaryDetailsInstance[0]["SUM(D.OOPREMPPO)"]}
								</span>
							</div>
						</div>
					</div>
					{/* ============================= CLAIM DETAILS ====================================*/}
					<div style={{ marginTop: 600 }}>
						<br />
						{/* <br /> */}
					</div>
					<div className="subheading-main">
						<HiDocumentReport />
						Claim Details
					</div>

					<ExplanationOfBenefitsGridPrint
						eligibleMembers={eobDetails?.claimDetailsInstance}
						claimTotal={eobDetails?.claimTotalInstance}
					/>

					{/* ============================= REMARKS ====================================*/}
					<div style={{ marginTop: 20 }}>
						<br />
					</div>
					<div className="subheading-main" style={{ marginTop: "40px" }}>
						<TbFileReport />
						Remarks
					</div>
					<p style={{ backgroundColor: "#d9d9d9", padding: 2, width: "fit-content" }}>
						{eobDetails?.claimantSubscriberDetailsInstance[0].FFMSG}
					</p>
					<Remarks remarks_list={eobDetails?.query5ExplanationCodesDetailsInstance} key={0} />
				</div>
			</div>
		);
	}
);

ExplanationOfBenefitFormPrint.displayName = "EOBPrint";
ExplanationOfBenefitFormPrint.propTypes = {
	eligibleMembers: PropTypes.any.isRequired
};

export default ExplanationOfBenefitFormPrint;
